import React, { forwardRef, useState } from 'react'

export const Form = forwardRef(function Form (props, ref) {
  const { className, children, method = 'POST', onSubmit: incomingOnSubmit = async () => {}, ...attrs } = props
  const [isSubmitting, setIsSubmitting] = useState(false)
  const onSubmit = evt => {
    evt.preventDefault()

    // Show 'loading' indicator if form is slow to submit
    const toggleSubmitting = setTimeout(() => {
      setIsSubmitting(true)
    }, 200)

    incomingOnSubmit(evt).then(() => clearTimeout(toggleSubmitting))
  }

  return (
    <form ref={ref} className={`flex flex-col gap-3 ${className} ${isSubmitting ? 'opacity-25' : ''}`} method={method} onSubmit={onSubmit} {...attrs}>
      {children}
    </form>
  )
})
